/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import sortBy from 'lodash-es/sortBy';
import { type Registry as Services, service } from '@ember/service';
import UiBookingPriceTablesBaseComponent from 'uplisting-frontend/components/ui/booking/price/tables/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class UiBookingPriceTablesBalanceComponent extends UiBookingPriceTablesBaseComponent {
  @service router!: Services['router'];

  @cached
  get showBalanceTable(): boolean {
    return (
      this.price.hasBalance &&
      !(this.router.currentRouteName ?? '').includes('booking-requests')
    );
  }

  @cached
  get balanceItems(): (
    | ModelRegistry['balance-adjustment']
    | ModelRegistry['history-booking-price']
  )[] {
    const { booking } = this.price;

    const existingBalanceAdjustments =
      booking?.balanceAdjustments.filter((item) => item.id) ?? [];

    const existingPriceChanges = booking?.priceChanges ?? [];

    return sortBy(
      [...existingBalanceAdjustments, ...existingPriceChanges],
      'createdAt',
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Tables::Balance': typeof UiBookingPriceTablesBalanceComponent;
  }
}
